import React from "react";
import { Rating } from "@mui/material";

interface StarRatingProps {
  value?: number;
  size?: "small" | "medium" | "large";
}

const StarRating: React.FC<StarRatingProps> = ({ value, size = "small" }) => {
  if (value == null) return null;

  return <Rating value={value} precision={0.5} size={size} readOnly />;
};

export default StarRating;
